const directions = { north:[0,-1], northeast:[1,-1], east:[1,0], southeast:[1,1], south:[0,1], southwest:[-1,1], west:[-1,0], northwest:[-1,-1] };
const names = ['east','southeast','south','southwest','west','northwest','north','northeast'];
export function nearbyOrigin(root) {
  const shapes = root?.shapes?.length ? root.shapes : root?.shape ? [root.shape] : [];
  const bounds = shapes.filter(shape => ['minX','maxX','minZ','maxZ'].every(key => Number.isFinite(Number(shape[key]))));
  if (bounds.length) return { x:(Math.min(...bounds.map(shape => Number(shape.minX)))+Math.max(...bounds.map(shape => Number(shape.maxX))))/2,
    z:(Math.min(...bounds.map(shape => Number(shape.minZ)))+Math.max(...bounds.map(shape => Number(shape.maxZ))))/2 };
  return { x:Number(root?.location?.x)||0, z:Number(root?.location?.z)||0 };
}
export function updateNearbyPlacement(site, changes, root) {
  const updated = { ...site,...changes };
  if (!('direction' in changes) && !('distanceMiles' in changes) && !('plannedLocation' in changes)) return updated;
  const origin = nearbyOrigin(root);
  let location = changes.plannedLocation;
  if (!location) {
    let vector = directions[updated.direction];
    if (!('direction' in changes) && site.plannedLocation) vector = [site.plannedLocation.x-origin.x,site.plannedLocation.z-origin.z];
    const magnitude = Math.hypot(...vector)||1, scale = updated.distanceMiles*5280/magnitude;
    location = { x:origin.x+vector[0]*scale, z:origin.z+vector[1]*scale };
  }
  const dx=location.x-origin.x, dz=location.z-origin.z;
  return { ...updated, plannedLocation:location, direction:names[(Math.round(Math.atan2(dz,dx)/(Math.PI/4))+8)%8],
    distanceMiles:Math.round(Math.hypot(dx,dz)/5280*1e6)/1e6 };
}
